const today = new Date();
today.setHours(6, 0, 0, 0);

export const ONE_DAY = 86400000;
export const NOON = ONE_DAY / 2;

export function oneWeekAgo(today: Date | null, days: number = 7) {
  if (today == null) {
    today = new Date();
  }
  today.setHours(6, 0, 0, 0);
  const timestamp = today.getTime();
  return timestamp - days * ONE_DAY - ONE_DAY / 2;
}


export function removeTimezone(d: Date) {
  const timeZoneDifference = (d.getTimezoneOffset() / 60) * -1
  d.setTime(d.getTime() + (timeZoneDifference * 60) * 60 * 1000);
  return d
}